

function CertificateDetails () {

    return (
        <div>
            Certificate details ...
        </div>
    )
}

export default CertificateDetails;